import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-modal-select-account',
  templateUrl: './modal-select-account.component.html',
  styleUrls: ['./modal-select-account.component.css'],
  standalone: false
})
export class ModalSelectAccountComponent implements OnInit {

  @Input() vm: any;

  @Output() selectAccountModalEmit = new EventEmitter<string>();
  @Output() updateAccountEmit = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
  }

  selectAccountModal(accountId){
    this.selectAccountModalEmit.emit(accountId);
  }

  updateAccount(){
    this.updateAccountEmit.emit();
  }

  // Return all accounts matching current filters across the full values list (not just the current page)
  getFilteredAccounts(): any[] {
    const list: any[] = Array.isArray(this.vm?.account) ? this.vm.account : [];
    const filter = this.vm?.accountFilter || {};

    const search = String(filter.search_string ?? '').toLowerCase().trim();
    const typeName = String(filter.type_name ?? '').toLowerCase().trim();

    return list.filter(acc => {
      if (!acc) {
        return false;
      }
      // Apply type filter if set
      if (typeName) {
        const accType = String(acc.type_name ?? '').toLowerCase();
        if (accType !== typeName) {
          return false;
        }
      }
      // Apply search across number and name
      if (search) {
        const num = String(acc.number ?? '').toLowerCase();
        const name = String(acc.name ?? '').toLowerCase();
        const combo = (num + ' ' + name).trim();
        if (!num.includes(search) && !name.includes(search) && !combo.includes(search)) {
          return false;
        }
      }
      return true;
    });
  }

}
